export const CLIENT_ID = "g8yvq8zk21cpsjtq2193e1applik3i";
